const initialState = {
  activeTab: "upload",
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_TAB':
      return {
        ...state,
        activeTab: action.payload
      };
    default:
      return state;
  }
};

export default appReducer; 